export default "__VITE_ASSET__Cd9$xwGh__"